<template>
    <!-- 城市选择 -->
    <div @click="setEditIndex(index)">
		<p v-if="isBankViewTest" class="my-bank-tag">{{$t('main.CitySelection')}}</p>
        <el-row :gutter="10" class="question-box">
            <el-col v-if="!isBankViewTest" :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">
                {{ question.quesIndex + 1 }}
            </el-col>
            <el-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15" class="item_container_title" @click="setActiveInput(question.qid)">
                
                 <span style="lineHeight: 30px" v-if="isBankViewTest && question.questionsName">{{question.questionsName}}</span>
				<TitleEditor 
                    :isTest="true"
					v-if="!isBankViewTest" 
					class="outline-none" 
					:qid="question.qid" 
					:class="question.qid"  
					:value="question.questionsName" 
                    :actionTitleEditorShow="activeInputId === question.qid"
					@childValueChange="val=>{ question.questionsName = val }" 
                ></TitleEditor>
            </el-col>
			<el-col class="setBtn-box" :xs="7" :sm="7" :md="7" :lg="7" :xl="7" v-if="!$route.query.index">
				<OperateWrap
					style="display: flex;
						width: 100%;
						justify-content: end;
					"
					:bankId="$route.query.bankId"	
					:question="question"
				></OperateWrap>
			</el-col>
        </el-row>
        

        <el-row :gutter="10" style="margin-top:12px; margin-bottom:20px">
            <div>
                <div  style="margin-left:50px">
                    <div class='selectCity'>
                        <fake-input class="inputvalue" :placeholder="$t('main.PleaseSelectAProvince')"  v-if="question.choiceRange >= 1"/>
                        <fake-input class="inputvalue" :placeholder="$t('main.PleaseSelectACity')" v-if="question.choiceRange >= 2" />
                        <fake-input class="inputvalue" :placeholder="$t('main.PleaseSelectADistrictOrCounty')" v-if="question.choiceRange >= 3" />
                    </div>
                    <fake-textarea class='addres' v-if="question.choiceRange == 4" :placeholder="$t('main.PleaseFillInTheDetailedAddress')" />
                </div>
            </div>
        </el-row>

        
    </div>
</template>
<script>
    import { mapActions, mapState } from 'vuex';
    import OperateWrap from "./collectToBank/operateaWrap.vue"
    import FakeInput from '@/components/FakeInput.vue';
    import FakeTextarea from '@/components/FakeTextarea.vue'
    import TitleEditor from "@/components/titleEditor/titleEditor.vue"
    export default {
        components:{
            FakeInput,
            FakeTextarea,
            TitleEditor,
            OperateWrap
        },
        data() {
            return {
                editOptionIndex: "0_0",
                input:"",
                input1:'',
                input2:'',
                input3:'',
                detailCity:true,
                detailQU:true,
                detailContry:true,
                detailprov:true,
            }
        },
        props: {
            question: {},
            editIndex: {type:Number,default:0},
            index: {type:Number,default:0},
            isExistPage: {type:Boolean,default:false},
            // 管理题库时查看试题 只可以删除
            isBankViewTest: {
                type: Boolean,
                default: false
            },
        },
        computed: {
            ...mapState(['activeInputId']),
        },
        methods: {
            ...mapActions(['setActiveInput']),
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            wjupdoption(item){
                this.$emit("wjupdoption",item);
            },
            wjaddquestionoption(optionList, item, type = 1) {
                this.$emit("wjaddquestionoption", optionList, item, type);
            },
            setEditIndex(index){
                this.$emit("setEditIndex",index);
            },
            setEditOptionIndex(childIndex){
                this.editOptionIndex = this.editIndex+"_"+childIndex;
            },
            wjdelquestionoption(options,item,childindex){
                this.$emit("wjdelquestionoption",options,item,childindex)
            },
        },
        created() {
            console.log('questionCity',this.question)
            if(this.question.choiceRange == 1){
                this.detailCity = false
            }else if(this.question.choiceRange == 2){
                this.detailCity = false
                this.detailQU = false
            }else if(this.question.choiceRange == 3){
                this.detailCity = false
                this.detailQU = false
                this.detailContry = false
            }
            
        },
        
    }
</script>

<style scoped lang="scss">
    .selectCity{
        display:flex;
        flex-direction: column;
    }
    .selectCity .inputvalue{
        width:400px;
        height:30px;
        line-height: 30px;
        border:1px solid #ccc !important;
        border-radius: 4px;
        margin-top:10px;
        text-indent: 20px;
    }
    .addres{
        width:431px;
        height:70px;
        border:1px solid #ccc !important;
        border-radius: 4px;
        margin-top:10px;
        text-indent: 20px;
    }
    .inputvalue{
        border: 1px solid rgb(154, 145, 145);
        width: 770px;
        height: 40px;
    }
    /* .el-input__inner{
        height:35px;
    } */
    /deep/.questionCity.el-input__inner:hover{
        border:none !important;
    }
.item .el-badge__content.is-fixed{top:10px;}
.item.drag-handle{
  cursor: move;
}
    .el_item_option {
        line-height: 40px;
        // height: 44px;
    }

    .el-icon-common {
        margin-right: 23px;
        font-size: 16px !important;
        line-height: 40px !important;
        color: cornflowerblue;
        cursor: pointer;
    }

    .el-icon-common-option {
        margin-left: 10px;
        font-size: 22px !important;
        line-height: 40px !important;
        color: cornflowerblue;
        cursor: pointer;
    }


    .item_container_title {
        padding-left: 0px !important;
        padding-right: 0px !important;
    }


</style>
